import { StoreType } from '@/enums';
import { IStoreProject } from '@/modules/dap/interfaces';

export class StoreProject implements IStoreProject {
  address = '';
  area = '';
  branchs = [];
  cep = '';
  city = '';
  dateClosing = undefined;
  dateConversion = undefined;
  dateOpening = new Date();
  dateSchedule = undefined;
  dealerNumber = 0;
  finalValidity = new Date();
  geocode = 0;
  groupName = '';
  id = 0;
  idCity = '';
  idEconomicGroup = -1;
  idStoreMatrix = 0;
  idStoreType = 0;
  idStoreTypeClient = StoreType['2S'];
  idUnique = '';
  initialValidity = new Date();
  isPermanent = false;
  latitude = 0;
  longitude = 0;
  name = '';
  neighborhood = '';
  percentDivision = 0;
  percentGrowth = 0;
  percentRate = 0;
  pointHistories = [];
  projectId = 0;
  state = '';
  typeName = '2S';
  updatedAt = undefined;
}
